module.exports = __webpack_public_path__ + "img/icon-ios.e6ad4336.svg";